var page = promokit.page({
    caution: '#section-caution',
    menu: false,
    cnb: true,
    topButton: true,

    headerButton: {
        el: '.header-button',
        sns: true,
    },

    footer: {
        theme:'black'
    },
});


$(document).on('click', '.btn-login', function(){
    promokit.login();
});

$(document).on('click', '.btn-coupon--login', function(){
    promokit.login();
});

var layer1 = promokit.layer({
    el: '#layer-1',
    buttons: '.btn-check',
    render: true
});

// layer1.open();

/*
$(document).on('click', '.btn-coupon--list', function() {
    window.promokitStore.layerCoupon.open()
});
*/


var tab = promokit.tab({
    el: '#tab-1',
    initActive: 0,
    fade: false,
    text: {
        0: '리니지',
        1: '리니지2',
        2: '아이온',
        3: '블레이드 & 소울',
        4: '리니지M',
        5: '리니지2M',
        6: 'H2',
        7: '버프툰'
    }
});

tab.on('change', (index) => {
    console.log('change')
    if(index.now==1){
        $(layer1.$config.el).css('height', 963)
    }else if(index.now==2){
        $(layer1.$config.el).css('height', 1032)
    }else{
        $(layer1.$config.el).css('height', 723)
    }
});



// WEBPACK FOOTER //
// ./src/js/baseball.js